var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"msg-title"},[_c('bread-crumb',[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ name: 'homePage' }}},[_vm._v("首页")]),_c('el-breadcrumb-item',[_vm._v("企业信息")])],1)],1),_c('div',{staticClass:"qymc"},[_vm._v("企业信息")])],1),_c('company-msg',{staticClass:"company-msg"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }